import { c as _c } from "react/compiler-runtime";
/**
 * IPhoneMockup Component
 *
 * Lightweight iPhone 15 Pro mockup extracted from Magic UI.
 * Pure SVG + Tailwind, zero dependencies.
 * Notch removed - content starts from top of screen.
 *
 * @see https://magicui.design/docs/components/iphone
 */

import type { HTMLAttributes, ReactNode } from "react";

// iPhone 15 Pro dimensions (from Magic UI)
const PHONE_WIDTH = 433;
const PHONE_HEIGHT = 882;
const SCREEN_X = 21.25;
const SCREEN_Y = 19.25;
const SCREEN_WIDTH = 389.5;
const SCREEN_HEIGHT = 843.5;
const SCREEN_RADIUS = 55.75;

// Percentage-based positioning for responsive scaling
const LEFT_PCT = SCREEN_X / PHONE_WIDTH * 100;
const TOP_PCT = SCREEN_Y / PHONE_HEIGHT * 100;
const WIDTH_PCT = SCREEN_WIDTH / PHONE_WIDTH * 100;
const HEIGHT_PCT = SCREEN_HEIGHT / PHONE_HEIGHT * 100;
const RADIUS_H = SCREEN_RADIUS / SCREEN_WIDTH * 100;
const RADIUS_V = SCREEN_RADIUS / SCREEN_HEIGHT * 100;
interface IPhoneMockupProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}
export default function IPhoneMockup(t0) {
  const $ = _c(17);
  let children;
  let props;
  let style;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      className: t1,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = style;
    $[4] = t1;
  } else {
    children = $[1];
    props = $[2];
    style = $[3];
    t1 = $[4];
  }
  const className = t1 === undefined ? "" : t1;
  const t2 = `relative inline-block w-full align-middle leading-none ${className}`;
  let t3;
  if ($[5] !== style) {
    t3 = {
      aspectRatio: `${PHONE_WIDTH}/${PHONE_HEIGHT}`,
      ...style
    };
    $[5] = style;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = children && <div className="pointer-events-auto absolute z-0 overflow-hidden bg-white" style={{
      left: `${LEFT_PCT}%`,
      top: `${TOP_PCT}%`,
      width: `${WIDTH_PCT}%`,
      height: `${HEIGHT_PCT}%`,
      borderRadius: `${RADIUS_H}% / ${RADIUS_V}%`
    }}>{children}</div>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      transform: "translateZ(0)"
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <defs><mask id="screenPunch" maskUnits="userSpaceOnUse"><rect x="0" y="0" width={PHONE_WIDTH} height={PHONE_HEIGHT} fill="white" /><rect x={SCREEN_X} y={SCREEN_Y} width={SCREEN_WIDTH} height={SCREEN_HEIGHT} rx={SCREEN_RADIUS} ry={SCREEN_RADIUS} fill="black" /></mask></defs>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <svg viewBox={`0 0 ${PHONE_WIDTH} ${PHONE_HEIGHT}`} fill="none" xmlns="http://www.w3.org/2000/svg" className="pointer-events-none absolute inset-0 size-full" style={t5}>{t6}<g mask="url(#screenPunch)"><path d="M2 73C2 32.6832 34.6832 0 75 0H357C397.317 0 430 32.6832 430 73V809C430 849.317 397.317 882 357 882H75C34.6832 882 2 849.317 2 809V73Z" className="fill-[#E5E5E5]" /><path d="M0 171C0 170.448 0.447715 170 1 170H3V204H1C0.447715 204 0 203.552 0 203V171Z" className="fill-[#E5E5E5]" /><path d="M1 234C1 233.448 1.44772 233 2 233H3.5V300H2C1.44772 300 1 299.552 1 299V234Z" className="fill-[#E5E5E5]" /><path d="M1 319C1 318.448 1.44772 318 2 318H3.5V385H2C1.44772 385 1 384.552 1 384V319Z" className="fill-[#E5E5E5]" /><path d="M430 279H432C432.552 279 433 279.448 433 280V384C433 384.552 432.552 385 432 385H430V279Z" className="fill-[#E5E5E5]" /><path d="M6 74C6 35.3401 37.3401 4 76 4H356C394.66 4 426 35.3401 426 74V808C426 846.66 394.66 878 356 878H76C37.3401 878 6 846.66 6 808V74Z" className="fill-white" /></g><path opacity="0.5" d="M174 5H258V5.5C258 6.60457 257.105 7.5 256 7.5H176C174.895 7.5 174 6.60457 174 5.5V5Z" className="fill-[#E5E5E5]" /></svg>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== props || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t8 = <div className={t2} style={t3} {...props}>{t4}{t7}</div>;
    $[12] = props;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}